// extracted by mini-css-extract-plugin
export default {"loaderPage":"LoaderPage_loaderPage__pEeJH"};